const discover = {
  "discover.page_title": "探索DEFINE®",
  "discover.trait_01.body": "色素夾在兩塊鏡片中間，確保與眼球零接觸，安全可靠",
  "discover.trait_01.title": "色素夾層設計^",
  "discover.trait_02.body": "高效的防紫外光保護 <br /> 97% UVB 以及 81% UVA",
  "discover.trait_02.title": "國際認可防UV<sup>##</sup>",
  "discover.trait_03.body": "透過透明三層設計配合細緻的手繪紋路，讓你眼神明亮通透，深邃放大，增強立體感",
  "discover.trait_03.title": "光透疊色揉合設計",
  "discover.trait_04.item_01.body": "獨有LACREON®鎖濕科技，20小時長效鎖濕¹，全日水潤舒適",
  "discover.trait_04.item_01.title": "保濕鎖水",
  "discover.trait_04.item_02.body": "輕薄的鏡片邊緣設計，減少眨眼時隱形眼鏡帶 來的刺激及不適",
  "discover.trait_04.item_02.title": "輕薄鏡片",
  "discover.trait_04.item_03.body": "低摩擦系數使鏡片更柔軟及更易配戴，提升全日舒適度",
  "discover.trait_04.item_03.title": "柔軟低模數",
  "discover.trait_04.title": "令雙眼全日舒適",
}

export const try_lenses = {
  "try_lenses.block_title": "探索 <span>DEFINE® CLASSIC</span> 經典大地色系",
  "try_lenses.virtual_mirror": "虛擬試戴",
}
export const product_range = {
  "product_range.block_title": "尋找最適合你的 <span>ACUVUE® DEFINE®</span>",
  "product_range.button.classic": "DEFINE® CLASSIC 經典大地色系",
  "product_range.button.fresh": "DEFINE® FRESH 大自然色系",
}

const discover_references = {
  "discover_references": "<p> ¹Data on file, JJVC September 2022 <br> ^Data on file, JJVC 2016 <br> <sup>##</sup>符合美國國家標準學會（ANSI）美國食物及藥物管理局（FDA）及國際標準組織（ISO）的標準 警告：有吸收紫外光能力的隱形眼鏡不能代替能阻擋紫外光的太陽眼鏡，因為有吸收紫外光能力的隱形眼鏡只覆蓋眼球的一部份。因此，隱形眼鏡配戴者必須按指示繼續配戴能阻擋紫外光的太陽眼鏡。長時間地曝露於紫外光輻射是白內障相關的危險因素之一。影響程度是基於一系列的因素，如環境因素（海拔、地理位置、雲層遮蓋）和個人因素（戶外運動的性質和程度）。防紫外光的隱形眼鏡能提供對有害紫外光輻射的防護，但並未有臨床研究證實配戴防紫外光隱形眼鏡能減少發生白內障和其他眼部疾病。請諮詢您的專業眼科視光師以獲取更多的信息。 </p>"
}

// export default discover;
export default {
  ...discover,
  ...try_lenses,
  ...product_range,
  ...discover_references
}


